// 存储值保持：0-不限，1-仅限新人，2-仅限持卡学员，3-仅限未持卡学员。
// 后台下拉/规则展示顺序单独排成 1 新人 → 3 未持卡 → 2 持卡：
// 1 是 3 的子集，3 是 2 的反面，展示上更连贯；不为展示顺序改存储值，避免迁移历史数据。
export const voucherPurchaseScopes = {
  all: {
    value: 0,
    name: '不限',
    tagType: 'success',
  },
  newStudent: {
    value: 1,
    name: '仅限新人',
    tagType: 'danger',
  },
  noCard: {
    value: 3,
    name: '仅限未持卡学员',
    tagType: 'info',
  },
  hasCard: {
    value: 2,
    name: '仅限持卡学员',
    tagType: 'warning',
  },
};

// 列表/详情单条展示用（与课次券列表的 findCardTicketPurchaseScope 对齐）
export function findVoucherPurchaseScopeItem(value) {
  const scope = Number(value);
  for (const key in voucherPurchaseScopes) {
    if (scope === voucherPurchaseScopes[key].value) return voucherPurchaseScopes[key];
  }
  return {};
}

// 兼容旧的数组返回用法
export function findVoucherPurchaseScope(value) {
  return [findVoucherPurchaseScopeItem(value)];
}
